import { GOOGLE_MAPS_API_KEY } from "@/constants/google-maps"
import { useJsApiLoader } from "@react-google-maps/api"

import type { LoadScriptProps } from "@react-google-maps/api"
import { Platform } from "react-native"

const LIBRARIES: LoadScriptProps["libraries"] = ["drawing"]

// The DrawingManager class was removed from the Maps JS API in v3.65,
// which crashes every screen that mounts a <DrawingManager> —
// set-center-pivot-path, set-linear-path, create-field,
// set-location-permanent. We first rode the quarterly channel to stay
// behind that (June 2026); quarterly itself reached 3.65 in August
// 2026 and broke the same four screens again, so this is now pinned
// to the last numbered release that still ships DrawingManager.
//
// This is a stopgap with a clock on it: Google keeps a numbered
// version available only until roughly four newer quarterlies exist
// (~12 months), after which requests for 3.64 fall forward to a
// current version and these screens break a third time. Migrate off
// DrawingManager before then.
// TODO: replace DrawingManager usage with click-to-add-vertex /
// click-to-drop-marker handlers (see [[google-maps-drawing-removal]]).
const MAPS_API_VERSION = "3.64"

export default function useLoadGoogleMaps() {
  if (Platform.OS === "web") {
    return useJsApiLoader({
      googleMapsApiKey: GOOGLE_MAPS_API_KEY,
      libraries: LIBRARIES,
      version: MAPS_API_VERSION,
    })
  }
  throw new TypeError(
    `useLoadGoogleMaps.web.ts is not supported on ${Platform.OS}`,
  )
}
